<template>
  <svg fill="currentColor" height="1em" viewBox="0 0 24 24" width="1em">
    <path
      d="M21.198 2.433a2.242 2.242 0 00-1.022.215l-8.609 3.33c-2.068.8-4.133 1.598-5.724 2.21a405.15 405.15 0 01-2.849 1.09c-.42.147-.99.332-1.473.901-.728.968.193 1.798.919 2.286 1.61.516 3.275 1.009 4.654 1.472.846 2.797 1.667 5.602 2.485 8.413.252.892.671 1.05.937 1.04.482.001.901-.292 1.376-.78l3.33-3.21 4.91 3.59c.945.535 2.16.045 2.49-1.012.295-1.069.654-2.515 1.04-4.115.794-3.235 1.85-7.512 2.4-9.73a2.27 2.27 0 00-.013-1.13 1.04 1.04 0 00-.493-.625 1.36 1.36 0 00-.673-.156z"></path>
  </svg>
</template>
